import { DATA_TESTS } from 'components/modules/Insurance/Insurance.constants';

export const bubbleConditions = {
  currentEPointsMemberDealer: ({ dealer }) => dealer.epointsDigitalDealMember,
  hasSomeEPointsMemberDealer: ({ dealers }) =>
    dealers?.some((dealer) => dealer.epointsDigitalDealMember),
};

export const BUBBLES = [
  {
    type: 'modal',
    id: '12.08.2025',
    video: 'https://storage.yandexcloud.net/img-mainpage.e-credit.one/video/archive.mp4',
    height: 360,
    pathname: '/applications/list',
    title: 'Быстрые кнопки на списке заявок',
    text: 'Архив или отказ от кредита в один клик',
  },
  {
    type: 'target',
    id: '04.07.2025.002',
    target: '[data-test="actionMenu-openButton"]',
    title: 'Быстрые кнопки на списке заявок',
    text:
      'Объединили все ключевые функции по заявке. Теперь можно перейти \n' +
      'в калькулятор или анкету, нажав \n' +
      'на кнопку',
    position: 'bottom',
    dataTest: 'actionMenuBubble',
  },
  {
    type: 'target',
    id: '29.08.2025',
    target: `[data-test="${DATA_TESTS.VIN_RECOGNITION_BUTTON}"]`,
    title: 'Распознавание по VIN',
    text: 'Укажите VIN, и мы заполним форму',
    position: 'bottom-start',
    dataTest: DATA_TESTS.VIN_RECOGNITION_INFO_BUBBLE,
  },
];
